import moment from 'moment';
export default {
  feeds(state) {
    return state.feeds;
  },
  isLoading(state) {
    return state.loading;
  },
  getContributors(state){
    return state.contributors;
  },
  getFollowedOrgs(state){
    return state.followedOrgs
  },
  error(state) {
    return state.loading;
  },
  getAllContributors(state){
    return state.allContributors
  },
  getReactedFeed(state){
    return state.reactedFeed;
  },
  feedScrollHeight: (state) => state.innerHeight,
  feedPageLimit: (state) => state.feedPage,
  hasMoreFeedPages: (state) => state.hasMoreFeedPages,
  recommendedConnections: (state) => state.recommendedConnections,
  recommendedOrganizations: (state) => state.recommendedOrganizations,
  postActivities: (state) => Array.from(state.postActivity.values()).sort((a,b)=>{
    const dateA = moment(a.created_at, 'DD MMMM YYYY | hh:mm A');
    const dateB = moment(b.created_at, 'DD MMMM YYYY | hh:mm A');
    return dateB - dateA;
  }),
  commentActivites: (state) => state.commentActivity,
  loadingFollowers: (state) => state.loadingFollowers,
  loadingFollowedOrgs: (state) => state.loadingFollowedOrgs,
  activityLoader: (state) => state.activityLoader,

  // activities: (state) => state.feeds.filter(feed=> feed.content_type === 'image'),
  feedComments: (state) => state.feedComments,
  allOrganizations: state => state.allOrganization,
  sharedPostId: state => state.sharedPostId,
  activityPage:  state => state.activityPage,
  hasMoreActivityPages:  state => state.hasMoreActivityPages
};
